export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'anti-aging',
    name: '抗衰保湿',
    description: '针对少妇肌肤特点，深入解析抗衰老与深层保湿的科学方法',
    icon: 'ri-drop-line',
  },
  {
    slug: 'postpartum',
    name: '产后修复',
    description: '产后肌肤与身体恢复的专业指导，重拾产前光彩',
    icon: 'ri-heart-pulse-line',
  },
  {
    slug: 'body-management',
    name: '身材管理',
    description: '科学的身材管理方案，紧致塑形与健康美体双管齐下',
    icon: 'ri-body-scan-line',
  },
  {
    slug: 'daily-care',
    name: '日常护理',
    description: '从洁面到防晒，建立少妇专属的日常护肤流程',
    icon: 'ri-sun-line',
  },
  {
    slug: 'seasonal',
    name: '季节护肤',
    description: '顺应四季变化，灵活调整护肤策略的实用指南',
    icon: 'ri-contrast-drop-2-line',
  },
];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  coverImage: string;
  date: string;
  readTime: string;
  author: string;
  tags: string[];
  isFeatured: boolean;
  content: ArticleSection[];
}

export interface ArticleSection {
  type: 'paragraph' | 'heading' | 'image' | 'list' | 'tip';
  content?: string;
  level?: 2 | 3;
  items?: string[];
}